import React, { useEffect, useState } from "react";
import { Loading } from "./Loading";
import {
  isOwnerResyncLoading,
  OWNER_RESYNC_LOADING_CHANGED_EVENT,
} from "../utils/deviceSessionOwnerResync";

/** Owner 接管同步设备数据时的全屏 loading */
const OwnerResyncLoadingOverlay: React.FC<{
  text?: string;
}> = ({ text = "正在同步设备数据，请稍候…" }) => {
  const [visible, setVisible] = useState(() => isOwnerResyncLoading());

  useEffect(() => {
    const sync = () => setVisible(isOwnerResyncLoading());
    sync();
    window.addEventListener(OWNER_RESYNC_LOADING_CHANGED_EVENT, sync);
    return () => {
      window.removeEventListener(OWNER_RESYNC_LOADING_CHANGED_EVENT, sync);
    };
  }, []);

  return (
    <Loading
      visible={visible}
      text={text}
      autoProgress
      autoProgressOptions={{ maxDuration: 12000 }}
    />
  );
};

export default OwnerResyncLoadingOverlay;
